import { AxiosInstance } from 'axios';
import { AccountSnapshot } from '../../models/account.model';

export default class AccountApi {
  readonly apiUrlPath = '/account';

  constructor(readonly httpClient: AxiosInstance) {}

  /**
   * Obter account snapshot (subscription activa + partner gls info + effectiver tier)
   */
  async getAccountSnapshot(email: string): Promise<AccountSnapshot | null> {
    const { data } = await this.httpClient.get(`${this.apiUrlPath}/${email}`);

    return data;
  }
}
